
<div class="hidden-sm hidden-md hidden-lg ">
  <app-nav ></app-nav>
</div>
<div class="visible-lg">
<app-headerhome ></app-headerhome>
</div>
<div class="container _mt-50 bg-buupass">
</div>

<div class="theme-page-section  theme-page-section-lg">
    <div class="container ">
      <div class="row">
         <!-- Sidebar -->
    <div class="col-md-3 col-lg-3 mb-4">
      <app-account-header
        [activeTab]="activeTab"
        (scrollToSection)="scrollTo($event)">
      </app-account-header>
    </div>
    <div class="col-md-9 col-lg-9">
    <div class="booking-history-section">
      <h3 class="booking-title">Booking History</h3>
    
      <div *ngIf="!isTripAvailable" class="booking-empty-state">
        <h4>You haven't made any bookings through buupass</h4>
        <p>You can retrieve any bookings that aren't already listed here.</p>
      </div>
    
      <div *ngIf="isTripAvailable" class="booking-table-wrapper">
        <table class="booking-table">
          <thead>
            <tr>
              <th></th>
              <th>Route</th>
              <th>Operator</th>
              <th>Date</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let trip of trips">
              <td>
                <i class="fa fa-bus booking-icon"></i>
              </td>
              <td>
                <p class="booking-route">{{ trip.route }}</p>
              </td>
              <td>
                <a href="#" class="booking-operator">{{ trip.operator }}</a>
              </td>
              <td>
                <p class="booking-date">{{ trip.departure_date }}</p>
              </td>
              <td>
                <p class="booking-price">Ksh {{ trip.total_amount }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
    

      </div>
    </div>
</div>
